import { IMaskInput } from 'react-imask';

import { InputBase, InputBaseProps, Text, TextInputProps } from '@mantine/core';

import { IconPhoneFilled } from '@tabler/icons-react';

import classes from './PhoneInput.module.css';

type TPhoneInputProps = {
	value?: string;
	onChange: (phoneNumber: string) => void;
} & Omit<TextInputProps, 'value' | 'onChange'> &
	Omit<InputBaseProps, 'value'>;

export const PhoneInput = ({ value, onChange, ...rest }: TPhoneInputProps) => {
	const normalizePhoneNumber = (rawValue: string) => {
		if (!rawValue) return '';

		return rawValue.replace(/\W/g, '');
	};

	return (
		<InputBase
			classNames={classes}
			component={IMaskInput}
			mask="+7(000)000-0000"
			placeholder="+7(000)000-0000"
			rightSection={<IconPhoneFilled opacity={0.5} />}
			label={
				<Text c="#667085" fz={12} fw={500} lh="normal" tt="uppercase">
					Номер телефона
				</Text>
			}
			size="md"
			value={value ?? ''}
			onAccept={(maskedValue: string) => onChange(normalizePhoneNumber(maskedValue))}
			{...rest}
		/>
	);
};
